import React, { useEffect, useState } from 'react';
import CustomTab from '../../../../CustomTab/CustomTab';
import FloorplanContent from '../PlanOption/FloorplanContent/FloorplanContent';
import OptionContent from './OptionContent/OptionContent';
import styles from './PlanOption.module.scss';

const PlanOption = ({ optionCheck, setOptionCheck, setTotalOptionPrice }) => {
	const [tab, setTab] = useState(0);

	return (
		<div className={styles.planOptionWrapper}>
			<CustomTab
				items={['Floor Plan', 'Options']}
				width={248}
				tab={tab}
				setTab={setTab}
			/>

			<div className={styles.content}>
				{tab === 0 ? (
					<FloorplanContent />
				) : (
					<OptionContent
						optionCheck={optionCheck}
						setOptionCheck={setOptionCheck}
						setTotalOptionPrice={setTotalOptionPrice}
					/>
				)}
			</div>
		</div>
	);
};

export default PlanOption;
